export default __webpack_public_path__ + "static/media/newsimplan-icon02-tc.ce8b778a.png";